import { dealwithLanguage } from "../../render-helper";

export default [ 
    {
      header: 'Language',
      render: 'key',
      renderHelper: [dealwithLanguage]
    },
    {
      header: 'Value',
      render: 'value',
      numFmt: '#,##', 
    },
  ];